<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light main-color sp-header">
      <div class="col col-sm-6">
        <a class="mr-4 text-light h2" href="#">{{this.config.projectName}}</a>
        <span class="text-light sp-header-text">納品完了・画像登録</span>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'DeliveryImageSpHeader',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DeliveryImageSpHeader.vue